// import { saveAs } from 'file-saver';
import { useEffect, useState } from "react";
import {
  FiChevronLeft,
  FiChevronRight,
  FiChevronsLeft,
  FiChevronsRight,
} from "react-icons/fi";
import { useLocation, useNavigate } from "react-router-dom";
// import * as XLSX from 'xlsx';
import { IoMdSearch } from "react-icons/io";
import { LIVE_URL } from "../../../config/config";
import useAuthToken from "../../../hooks/useAuthToken";
import styles from "./css/ListQualities.module.scss";
import ProductTable from "./datatable/ProductTable";

const ListQualities = () => {
  const { token } = useAuthToken();
  const navigate = useNavigate();
  const location = useLocation();

  // define state
  const [title, setTitle] = useState(
    new URLSearchParams(location.search).get("title") || ""
  );
  const [qualities, setQualities] = useState([]);
  const [filteredQualities, setFilteredQualities] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [entriesPerPage, setEntriesPerPage] = useState(10);
  const [limit, setLimit] = useState(10);
  const [sortField, setSortField] = useState("id");
  const [sortOrder, setSortOrder] = useState("DESC");
  const [popupMessage, setPopupMessage] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchQualitiesData = async () => {
      try {
        setLoading(true);
        const queryParams = new URLSearchParams();
        if (title) {
          queryParams.set("title", title);
        } else {
          queryParams.set("page", currentPage);
          queryParams.set("pageSize", entriesPerPage);
          queryParams.set("sort_by", sortField);
          queryParams.set("order_by", sortOrder);
          queryParams.set("limit", limit);
        }

        const response = await fetch(
          `${LIVE_URL}/admin/value-in-person/list?${queryParams}`,
          {
            method: "POST",
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );

        if (response.ok) {
          const data = await response.json();

          if (data?.data?.value_in_person) {
            setQualities(data.data.value_in_person);
            setFilteredQualities(data.data.value_in_person);
            setTotalPages(
              Math.ceil(data.data.pagination.totalCount / entriesPerPage)
            );
          } else {
            setQualities([]);
            setFilteredQualities([]);
            setTotalPages(1);
          }
        } else {
          setQualities([]);
          setFilteredQualities([]);
          setTotalPages(1);
        }
      } catch (error) {
        setQualities([]);
        setFilteredQualities([]);
        setTotalPages(1);
      } finally {
        setLoading(false);
      }
    };

    if (!loading) {
      fetchQualitiesData();
    }
  }, [token, currentPage, title, entriesPerPage, limit, sortField, sortOrder]);

  useEffect(() => {
    if (qualities) {
      const filtered = qualities.filter((qualities) =>
        qualities.title.toLowerCase().includes(title.toLowerCase())
      );
      setFilteredQualities(filtered);
    } else {
      setFilteredQualities(qualities);
    }
  }, [title, qualities]);

  useEffect(() => {
    if (location.search) {
      const params = new URLSearchParams(location.search);
      const message = params.get("message");
      if (message) {
        setPopupMessage(decodeURIComponent(message));
        setTimeout(() => {
          setPopupMessage("");
          navigate({ search: "" });
        }, 2000);
      }
    }
  }, [location.search, navigate]);

  const handleLimitChange = (event) => {
    const newLimit = parseInt(event.target.value, 10);
    setLimit(newLimit);
    setEntriesPerPage(newLimit);
    setCurrentPage(1);
    setTotalPages(Math.ceil(filteredQualities.length / newLimit));
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handlePrevious = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const handleNext = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  // Added function to go two pages back
  const handlePreviousTwo = () => {
    if (currentPage !== 1) {
      setCurrentPage(1);
    }
  };

  // Added function to go two pages forward
  const handleNextTwo = () => {
    if (currentPage !== totalPages) {
      setCurrentPage(totalPages);
    }
  };

  const getPageNumbers = () => {
    const pageNumbers = [];
    if (currentPage > 1) {
      pageNumbers.push(currentPage - 1);
    }
    pageNumbers.push(currentPage);
    if (currentPage < totalPages) {
      pageNumbers.push(currentPage + 1);
    }
    return pageNumbers;
  };

  const updateUrl = (search) => {
    const params = new URLSearchParams(location.search);
    if (search) {
      params.set("title", search);
    } else {
      params.delete("title");
    }
    navigate({ search: params.toString() });
  };

  useEffect(() => {
    updateUrl(title);
  }, [title]);

  // const exportToExcel =  () => {
  //   const worksheet = XLSX.utils.json_to_sheet(filteredRelations);
  //   const workbook = XLSX.utils.book_new();
  //   XLSX.utils.book_append_sheet(workbook, worksheet, "Relation");
  //   const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
  //   const data = new Blob([excelBuffer], { type: "application/octet-stream" });
  //   saveAs(data, "relation.xlsx");
  // };

  return (
    <>
      <div className={`${styles.list_qualities}`}>
        {popupMessage && (
          <div className={`${styles.update_message}`}>
            <p>{popupMessage}</p>
          </div>
        )}
        <header>
          <h2>Qualities List Management</h2>
        </header>
        {/* entry section */}
        <section className={`${styles.section}`}>
          <div className={`${styles.user_entry}`}>
            <div className={`${styles.entries}`}>
              <label htmlFor="limit">Show</label>
              <select value={limit} onChange={handleLimitChange}>
                <option value="10">10</option>
                <option value="25">25</option>
                <option value="50">50</option>
                <option value="100">100</option>
              </select>
              <label htmlFor="entries">entries</label>
            </div>
            {/* <div className={`${styles.search_section}`}> */}
            <div className={`${styles.search}`}>
              {/* <label htmlFor="search">Search: </label> */}
              <IoMdSearch />
              <input
                type="search"
                id="search"
                value={title}
                placeholder="Search by title"
                onChange={(e) => setTitle(e.target.value)}
              />
            </div>
            {/* <div className={`${styles.export_button}`}>
                <button onClick={exportToExcel}>Export</button>
              </div>
            </div> */}
          </div>

          {/* user information section */}
          <div className={`${styles.user_info}`}>
            <ProductTable
              qualities={filteredQualities}
              setQualities={setQualities}
              rows={entriesPerPage}
              title={title}
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
              sortField={sortField}
              sortOrder={sortOrder}
              setSortField={setSortField}
              setSortOrder={setSortOrder}
              loading={loading}
            />
          </div>

          {/* pagination section */}
          <div className={`${styles.pagination}`}>
            <button onClick={handlePreviousTwo} disabled={currentPage === 1}>
              <FiChevronsLeft />
            </button>
            <button onClick={handlePrevious} disabled={currentPage === 1}>
              <FiChevronLeft />
            </button>
            {getPageNumbers().map((page) => (
              <button
                key={page}
                onClick={() => handlePageChange(page)}
                className={currentPage === page ? styles.active : ""}
                disabled={page > totalPages}
              >
                {page}
              </button>
            ))}
            <button onClick={handleNext} disabled={currentPage === totalPages}>
              <FiChevronRight />
            </button>
            <button
              onClick={handleNextTwo}
              disabled={
                currentPage === totalPages || currentPage === totalPages - 1
              }
            >
              <FiChevronsRight />
            </button>
          </div>
        </section>
      </div>
    </>
  );
};

export default ListQualities;
